<script>
export default {
  name: 'AccordionComponents',
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      viewAccordion: false
    }
  }
}
</script>

<template>
  <div>
    <h2>
      <button @click="viewAccordion = !viewAccordion" class="flex items-center justify-between w-full py-5 font-medium rtl:text-right text-gray-500 border-b border-gray-200 dark:border-gray-700 dark:text-gray-400 gap-3">
        <span>
          {{ title }}
        </span>
        <svg data-accordion-icon class="w-3 h-3 rotate-180 shrink-0" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5 5 1 1 5"/>
        </svg>
      </button>
    </h2>
    <div :class="viewAccordion ? 'my-5' : 'hidden my-5'">
      <slot />
    </div>
  </div>
</template>

